module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/twdesign-ff4703821a3f174b3f07c49782766538.svg&quot;;"